import { render, staticRenderFns } from "./ContactBoxLarge.vue?vue&type=template&id=a52d3218&scoped=true&"
import script from "./ContactBoxLarge.vue?vue&type=script&lang=js&"
export * from "./ContactBoxLarge.vue?vue&type=script&lang=js&"
import style0 from "./ContactBoxLarge.vue?vue&type=style&index=0&id=a52d3218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52d3218",
  null
  
)

export default component.exports